import {useQuery} from 'react-query';
import {getCitySponsorInformation} from '.';

const useGetCitiesSponsorInformation = (states: string) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['cities', states],
    queryFn: () => getCitySponsorInformation(states),
    enabled: states.length ? true : false,
  });
  return {cities: data, isLoading, refetch};
};

export default useGetCitiesSponsorInformation;
